import { render } from "./AssignInstructorModal.vue?vue&type=template&id=ceb537c0&scoped=true"
import script from "./AssignInstructorModal.vue?vue&type=script&lang=js"
export * from "./AssignInstructorModal.vue?vue&type=script&lang=js"

import "./AssignInstructorModal.vue?vue&type=style&index=0&id=ceb537c0&scoped=true&lang=css"
/* custom blocks */
import block0 from "./AssignInstructorModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb537c0"]])

export default __exports__